(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[98555],{

/***/ 22257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_getMobilePlatform__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62647);
/* harmony import */ var is_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63805);
/* harmony import */ var is_mobile__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(is_mobile__WEBPACK_IMPORTED_MODULE_2__);




var DiscountBannerMobile = function(param) {
    var src = param.src, roundedClass = param.roundedClass;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isPhone = ref[0], setIsPhone = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), href = ref1[0], setHref = ref1[1];
    var isWide = src === null || src === void 0 ? void 0 : src.includes("1350x210");
    var aspectClass = isWide ? "aspect-[1350/210]" : "aspect-[900/150]";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var mobile = is_mobile__WEBPACK_IMPORTED_MODULE_2___default()();
        setIsPhone(mobile);
        if (mobile) {
            setHref((0,_utils_getMobilePlatform__WEBPACK_IMPORTED_MODULE_3__/* .getMobilePlatform */ .W)() === "ios" ? "https://apps.apple.com/us/app/villavillam/id6757299847" : "https://play.google.com/store/apps/details?id=com.villavillam.app");
        }
    }, []);
    var className = "block w-full bg-contain bg-no-repeat bg-center relative ".concat(aspectClass, " ").concat(roundedClass, " my-6");
    var style = {
        backgroundImage: "url(".concat(src, ")")
    };
    if (!isPhone) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            style: style
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        className: className,
        style: style
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DiscountBannerMobile);


/***/ }),

/***/ 91450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _react_icons_all_files_hi_HiXCircle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32757);
/* harmony import */ var _react_icons_all_files_hi_HiExclamation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80297);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73040);





var ErrorComp = function(param) {
    var children = param.children, _type = param.type, type = _type === void 0 ? "error" : _type;
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .m)(), errorTitle = ref.errorTitle, attention = ref.attention;
    if (!children) return null;
    var styles = {
        error: {
            container: "bg-red-50 border-red-200",
            iconBg: "text-red-400",
            titleColor: "text-red-800",
            textColor: "text-red-700",
            title: "Hata",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_hi_HiXCircle__WEBPACK_IMPORTED_MODULE_3__/* .HiXCircle */ .V, {
                className: "h-5 w-5",
                "aria-hidden": "true"
            })
        },
        warning: {
            container: "bg-yellow-50 border-yellow-200",
            iconBg: "text-yellow-400",
            titleColor: "text-yellow-800",
            textColor: "text-yellow-700",
            title: "Uyar\u0131",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_hi_HiExclamation__WEBPACK_IMPORTED_MODULE_4__/* .HiExclamation */ .H, {
                className: "h-5 w-5",
                "aria-hidden": "true"
            })
        }
    };
    // type prop'u hatalı gelirse varsayılan olarak 'error' kullan
    var activeStyle = styles[type] || styles.error;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "rounded-md p-4 border ".concat(activeStyle.container, " mb-4"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: activeStyle.iconBg,
                        children: activeStyle.icon
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "ml-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-sm font-medium ".concat(activeStyle.titleColor),
                            children: type === "warning" ? attention : errorTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-2 text-sm ".concat(activeStyle.textColor),
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorComp);


/***/ }),

/***/ 98555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_FastReservation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/DefaultCurrencyFormat.js
var DefaultCurrencyFormat = __webpack_require__(16543);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/FastReservation/Warning.js


var Warning = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-4 p-3 text-white  border  rounded-md text-sm bg-primary border-primary ",
        children: children
    });
};
/* harmony default export */ var FastReservation_Warning = (Warning);

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(11355);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 16 modules
var dialog = __webpack_require__(39627);
;// CONCATENATED MODULE: ./components/Modal.js



var Modal = function(param) {
    var isOpen = param.isOpen, closeModal = param.closeModal, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
        appear: true,
        show: isOpen,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: "relative z-[9999]",
            onClose: closeModal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 bg-[#1f2937] bg-opacity-30"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "transition-opacity duration-200",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "transition-opacity duration-150",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ var components_Modal = (Modal);

;// CONCATENATED MODULE: ./components/FastReservation/ServiceRow.js








var ServiceRow = function(param) {
    var service = param.service, symbol = param.symbol, isOptional = param.isOptional, isSelected = param.isSelected, onServiceChange = param.onServiceChange, AvailableExtraServices = param.AvailableExtraServices;
    var ref = (0,TranslationContext/* useTranslation */.m)(), nightLabel = ref.nightLabel, moreInfo = ref.moreInfo, free = ref.free, dateLabel = ref.dateLabel, amountLabel = ref.amountLabel, statusLabel = ref.statusLabel, statusAvailable = ref.statusAvailable, statusUnavailable = ref.statusUnavailable, serviceFreePre = ref.serviceFreePre, serviceFreeStrong = ref.serviceFreeStrong, serviceFreePost = ref.serviceFreePost, servicePaidPre = ref.servicePaidPre, servicePaidPost = ref.servicePaidPost;
    var ref1 = (0,react.useState)(false), showDetails = ref1[0], setShowDetails = ref1[1];
    var value = Number(service.amount) * (service.Type === "1" ? 1 : service.totalDays);
    var availableDates = AvailableExtraServices === null || AvailableExtraServices === void 0 ? void 0 : AvailableExtraServices.map(function(serviceItem) {
        var findService = serviceItem.extraServices.find(function(s) {
            return s.id === service.id;
        });
        return {
            date: serviceItem.date,
            price: findService === null || findService === void 0 ? void 0 : findService.amount,
            status: findService ? 1 : 0
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col w-full text-13",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-4 justify-between items-start w-full cursor-pointer",
                onClick: function(e) {
                    if (isOptional) {
                        e.preventDefault();
                        onServiceChange(service.id);
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col flex-grow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium opacity-80 mb-0.5",
                                children: service.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-xs opacity-60",
                                children: [
                                    service.totalDays,
                                    " ",
                                    nightLabel,
                                    " ",
                                    api/* GetPriceList */._Q,
                                    " -",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function(e) {
                                            e.stopPropagation();
                                            setShowDetails(!showDetails);
                                        },
                                        type: "button",
                                        className: "underline outline-none hover:text-orange transition-colors",
                                        children: moreInfo
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-end gap-1 shrink-0 mt-0.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold whitespace-nowrap",
                                children: service.amount === "0" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-bold opacity-60",
                                    children: free
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                    Symbol: symbol,
                                    value: value
                                })
                            }),
                            isOptional && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "relative inline-flex h-4 w-7 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ".concat(isSelected ? "bg-orange" : "bg-gray-300"),
                                role: "switch",
                                "aria-checked": isSelected,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ".concat(isSelected ? "translate-x-3" : "translate-x-0")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Modal, {
                isOpen: showDetails,
                closeModal: function() {
                    return setShowDetails(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 flex items-center justify-center p-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                        className: "w-full max-w-xl rounded-lg bg-white p-6 shadow-lg max-h-full my-2 overflow-y-auto relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return setShowDetails(false);
                                },
                                className: "absolute top-4 right-4 text-gray-500 hover:text-gray-700",
                                children: "X"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Title */.V.Title, {
                                className: "text-lg font-medium text-gray-900",
                                children: service.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "overflow-x-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                            className: "min-w-full divide-y divide-gray-200",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        className: "bg-gray-50",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                scope: "col",
                                                                className: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                children: dateLabel
                                                            }),
                                                            service.Type == "0" && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                scope: "col",
                                                                className: "px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-center",
                                                                children: amountLabel
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                scope: "col",
                                                                className: "px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider w-16 ",
                                                                children: statusLabel
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                    className: "bg-white divide-y divide-gray-200",
                                                    children: availableDates === null || availableDates === void 0 ? void 0 : availableDates.map(function(detail, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                            className: "hover:bg-gray-50 transition-colors",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    className: "px-4 py-3 text-sm text-gray-900",
                                                                    children: new Date(detail.date).toLocaleDateString( false ? 0 : "tr-TR")
                                                                }),
                                                                service.Type == "0" && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    className: "px-4 py-3 text-sm text-gray-900 text-center",
                                                                    children: detail.price ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                                                        Symbol: symbol,
                                                                        value: detail.price
                                                                    }) : "-"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    className: "px-4 py-3 ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ".concat(detail.status === 1 ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-800"),
                                                                        children: detail.status === 1 ? statusAvailable : statusUnavailable
                                                                    })
                                                                })
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                            ]
                                        }),
                                        value == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FastReservation_Warning, {
                                            children: [
                                                serviceFreePre,
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: serviceFreeStrong
                                                }),
                                                " ",
                                                serviceFreePost
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(FastReservation_Warning, {
                                            children: [
                                                servicePaidPre,
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                                            Symbol: symbol,
                                                            value: value
                                                        }),
                                                        " "
                                                    ]
                                                }),
                                                servicePaidPost
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var FastReservation_ServiceRow = (ServiceRow);

// EXTERNAL MODULE: ./components/DiscountBannerMobile.js
var DiscountBannerMobile = __webpack_require__(22257);
;// CONCATENATED MODULE: ./components/FastReservation/Result.js







var Result = function(param) {
    var result = param.result, buyPool = param.buyPool, paymentType = param.paymentType, _mandatoryServices = param.mandatoryServices, mandatoryServices = _mandatoryServices === void 0 ? [] : _mandatoryServices, _optionalServices = param.optionalServices, optionalServices = _optionalServices === void 0 ? [] : _optionalServices, selectedServices = param.selectedServices, handleServiceChange = param.handleServiceChange, AvailableExtraServices = param.AvailableExtraServices, isAppWebView = param.isAppWebView;
    var ref, ref1, ref2;
    var ref3 = (0,TranslationContext/* useTranslation */.m)(), reservationSummary = ref3.reservationSummary, accommodationAmount = ref3.accommodationAmount, remainingAmount = ref3.remainingAmount, cleaningFee = ref3.cleaningFee, totalPrice = ref3.totalPrice, depositPrice = ref3.depositPrice, discount = ref3.discount, discountedAccommodationAmount = ref3.discountedAccommodationAmount, mobileAppDiscount = ref3.mobileAppDiscount, promoCodeDiscount = ref3.promoCodeDiscount, heatedPool = ref3.heatedPool, free = ref3.free, optionalServicesTitle = ref3.optionalServices;
    var filtered = result === null || result === void 0 ? void 0 : (ref = result.result) === null || ref === void 0 ? void 0 : (ref1 = ref.isitmaUcretleri) === null || ref1 === void 0 ? void 0 : ref1.filter(function(x) {
        return x.isitmaHizmetDisi === "0";
    });
    // gruplama ve sayma
    var grouped = filtered === null || filtered === void 0 ? void 0 : filtered.reduce(function(acc, item) {
        var fiyat = item.isitmaFiyat;
        acc[fiyat] = (acc[fiyat] || 0) + 1;
        return acc;
    }, {});
    // string çıktısı üretme
    var IsitmaComp = function() {
        if (!grouped) return null;
        var entries = Object.entries(grouped);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: entries.map(function(param, index) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), fiyat = _param[0], count = _param[1];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                            Symbol: result.result.symbol,
                            value: fiyat
                        }),
                        " ",
                        "x ",
                        count,
                        index < entries.length - 1 ? ", " : ""
                    ]
                }, fiyat);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            !isAppWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sm:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountBannerMobile/* default */.Z, {
                    src: "/images/discount-banner-mobile.png"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-detail-border-color px-7 pt-4 pb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mb-3 font-semibold text-base tracking-11 text-orange",
                        children: reservationSummary
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-13 flex justify-between mt-3 items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium opacity-60",
                                children: accommodationAmount.replace("{night}", result.result.night)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold ".concat(result.result.old_price || result.result.old_price2 ? "line-through text-red-600" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                    Symbol: result.result.symbol,
                                    value: result.result.old_price2 || result.result.old_price || result.result.accommodation_fee
                                })
                            })
                        ]
                    }),
                    result.result.IndirimTutari > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-13 flex justify-between mt-3 items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium opacity-60",
                                children: isAppWebView && (result === null || result === void 0 ? void 0 : (ref2 = result.result) === null || ref2 === void 0 ? void 0 : ref2.MobileOzel) ? mobileAppDiscount : discount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold text-green-600",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                    Symbol: result.result.symbol,
                                    value: result.result.IndirimTutari
                                })
                            })
                        ]
                    }),
                    result.result.PromotionDiscountPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-13 flex justify-between mt-3 items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium opacity-60",
                                children: (result === null || result === void 0 ? void 0 : result.MobileOzel) == true ? mobileAppDiscount : promoCodeDiscount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold text-green-600",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                    Symbol: result.result.symbol,
                                    value: result.result.PromotionDiscountPrice
                                })
                            })
                        ]
                    }),
                    result.result.old_price || result.result.old_price2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-13 flex justify-between mt-3 items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium opacity-60",
                                children: discountedAccommodationAmount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                    Symbol: result.result.symbol,
                                    value: result.result.accommodation_fee
                                })
                            })
                        ]
                    }) : "",
                    result.result.cleaning_fee ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-13 flex justify-between mt-3 items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium opacity-60",
                                children: cleaningFee
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                    Symbol: result.result.symbol,
                                    value: result.result.cleaning_fee
                                })
                            })
                        ]
                    }) : "",
                    buyPool && result.result.isitmaHizmetDisi != "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-13 flex justify-between mt-3 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "font-medium opacity-60",
                                    children: [
                                        heatedPool,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "font-bold text-black",
                                            children: [
                                                "(",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IsitmaComp, {}),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-bold",
                                    children: result.result.pool_fee ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                        Symbol: result.result.symbol,
                                        value: result.result.pool_fee
                                    }) : free
                                })
                            ]
                        })
                    }) : "",
                    (mandatoryServices === null || mandatoryServices === void 0 ? void 0 : mandatoryServices.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full border-t border-black border-opacity-10 mt-4 pt-4",
                        children: mandatoryServices === null || mandatoryServices === void 0 ? void 0 : mandatoryServices.map(function(service, index) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: "mb-3 last:mb-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FastReservation_ServiceRow, {
                                    service: service,
                                    symbol: result === null || result === void 0 ? void 0 : (ref = result.result) === null || ref === void 0 ? void 0 : ref.symbol,
                                    isOptional: false,
                                    isSelected: true,
                                    AvailableExtraServices: AvailableExtraServices
                                })
                            }, "man-".concat(index));
                        })
                    }),
                    (optionalServices === null || optionalServices === void 0 ? void 0 : optionalServices.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full mt-6 mb-2 border-b border-black border-opacity-10 pb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-3 mb-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-px bg-black bg-opacity-10 flex-grow"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-13 font-bold opacity-80 whitespace-nowrap",
                                        children: optionalServicesTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-px bg-black bg-opacity-10 flex-grow"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-2",
                                children: optionalServices.map(function(service, index) {
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: "mb-4 last:mb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FastReservation_ServiceRow, {
                                            AvailableExtraServices: AvailableExtraServices,
                                            service: service,
                                            symbol: result === null || result === void 0 ? void 0 : (ref = result.result) === null || ref === void 0 ? void 0 : ref.symbol,
                                            isOptional: true,
                                            isSelected: selectedServices === null || selectedServices === void 0 ? void 0 : selectedServices.has(service.id),
                                            onServiceChange: handleServiceChange
                                        })
                                    }, "opt-".concat(index));
                                })
                            })
                        ]
                    }),
                    result.result.cleaning_fee || result.result.extra_price > 0 || result.result.pool_fee && buyPool && result.result.isitmaHizmetDisi != "1" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-13 flex justify-between mt-3 items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium opacity-60",
                                children: totalPrice
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-bold",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                        Symbol: result.result.symbol,
                                        value: result.result.total_price
                                    })
                                ]
                            })
                        ]
                    }) : ""
                ]
            }),
            (result.result.deposit_price > 0 && paymentType !== "all" || result.result.remaining_price > 0 && paymentType !== "all") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-gray-200 px-7 py-3",
                children: [
                    result.result.deposit_price > 0 && paymentType !== "all" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-13 flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium opacity-60",
                                children: depositPrice
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                    Symbol: result.result.symbol,
                                    value: result.result.deposit_price
                                })
                            })
                        ]
                    }),
                    result.result.remaining_price > 0 && paymentType !== "all" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-13 flex justify-between mt-3 items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium opacity-60",
                                children: remainingAmount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                    Symbol: result.result.symbol,
                                    value: result.result.remaining_price
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-detail-border-color px-7 py-1"
            })
        ]
    });
};
/* harmony default export */ var FastReservation_Result = (Result);

;// CONCATENATED MODULE: ./components/FastReservation/SendBtn.js


var SendBtn = function(param) {
    var submitForm = param.submitForm, disabled = param.disabled, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        disabled: disabled,
        className: "font-semibold w-full cursor-pointer text-white text-sm !leading-[37px] py-3 bg-greenGra lg:text-xs xl:text-sm " + (disabled ? "disabled opacity-70" : ""),
        onClick: function(e) {
            return submitForm();
        },
        children: children
    });
};
/* harmony default export */ var FastReservation_SendBtn = (SendBtn);

// EXTERNAL MODULE: ./node_modules/react-date-range/dist/index.js
var dist = __webpack_require__(30286);
// EXTERNAL MODULE: ./components/Detail/Icons.js
var Icons = __webpack_require__(80103);
// EXTERNAL MODULE: ./node_modules/react-detect-click-outside/dist/index.js
var react_detect_click_outside_dist = __webpack_require__(49689);
// EXTERNAL MODULE: ./components/windowDimension.js
var windowDimension = __webpack_require__(16625);
// EXTERNAL MODULE: ./helper/useLocale.js
var useLocale = __webpack_require__(92072);
;// CONCATENATED MODULE: ./components/FastReservation/FormDatepicker.js









var FormDatepicker = function(param) {
    var state2 = param.state2, setState2 = param.setState2, dates = param.dates, setError = param.setError;
    var ToggleShow = function ToggleShow() {
        setIsShow(!isShow);
    };
    var CloseToggle = function CloseToggle() {
        setIsShow(false);
    };
    var onChange = function onChange(item) {
        setState2([
            item.selection
        ]);
        setError(false);
        if (item.selection.startDate !== item.selection.endDate) {
            CloseToggle();
        }
    };
    var customDayContent = function customDayContent(day) {
        var classname = null;
        if ((doluGirisler === null || doluGirisler === void 0 ? void 0 : doluGirisler.filter(function(x) {
            return day.toDateString() == x.toDateString();
        }).length) > 0 && (doluCikislar === null || doluCikislar === void 0 ? void 0 : doluCikislar.filter(function(x) {
            return day.toDateString() == x.toDateString();
        }).length) > 0) {
            classname = "doluGirdiCikti";
        } else if ((doluGunler === null || doluGunler === void 0 ? void 0 : doluGunler.filter(function(x) {
            return day.toDateString() == x.toDateString();
        }).length) > 0) {
            classname = "doluGunler";
        } else if ((doluCikislar === null || doluCikislar === void 0 ? void 0 : doluCikislar.filter(function(x) {
            return day.toDateString() == x.toDateString();
        }).length) > 0) {
            classname = "doluCikis";
        } else if ((doluGirisler === null || doluGirisler === void 0 ? void 0 : doluGirisler.filter(function(x) {
            return day.toDateString() == x.toDateString();
        }).length) > 0) {
            classname = "doluGiris";
        } else if ((odemeGirisler === null || odemeGirisler === void 0 ? void 0 : odemeGirisler.filter(function(x) {
            return day.toDateString() == x.toDateString();
        }).length) > 0) {
            classname = "odemeGiris";
        } else if ((odemeCikislar === null || odemeCikislar === void 0 ? void 0 : odemeCikislar.filter(function(x) {
            return day.toDateString() == x.toDateString();
        }).length) > 0) {
            classname = "odemeCikis";
        } else if ((odemeGunler === null || odemeGunler === void 0 ? void 0 : odemeGunler.filter(function(x) {
            return day.toDateString() == x.toDateString();
        }).length) > 0) {
            classname = "odemeGunler";
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "absolute inset-0 ".concat(classname),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-white",
                children: (0,format["default"])(day, "d")
            })
        });
    };
    var localeData = (0,useLocale/* default */.Z)();
    var ref = (0,TranslationContext/* useTranslation */.m)(), datepickerCheckIn = ref.datepickerCheckIn, datepickerCheckOut = ref.datepickerCheckOut;
    var ref1 = (0,react.useState)((0,format["default"])(state2[0].startDate, "dd")), dayStart = ref1[0], setdayStart = ref1[1];
    var ref2 = (0,react.useState)((0,format["default"])(state2[0].endDate, "dd")), dayEnd = ref2[0], setdayEnd = ref2[1];
    var ref3 = (0,react.useState)(false), isShow = ref3[0], setIsShow = ref3[1];
    var ref4 = (0,react.useState)([]), doluGirisler = ref4[0], setDoluGirisler = ref4[1];
    var ref5 = (0,react.useState)([]), doluCikislar = ref5[0], setDoluCikislar = ref5[1];
    var ref6 = (0,react.useState)([]), doluGunler = ref6[0], setDoluGunler = ref6[1];
    var ref7 = (0,react.useState)([]), odemeGirisler = ref7[0], setOdemeGirisler = ref7[1];
    var ref8 = (0,react.useState)([]), odemeCikislar = ref8[0], setOdemeCikislar = ref8[1];
    var ref9 = (0,react.useState)([]), odemeGunler = ref9[0], setOdemeGunler = ref9[1];
    var ref10 = (0,react.useState)(), monthStart = ref10[0], setmonthStart = ref10[1];
    var ref11 = (0,react.useState)(), monthEnd = ref11[0], setmonthEnd = ref11[1];
    var width = (0,windowDimension/* default */.Z)().width;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        setDoluGunler((ref = dates.doluGunler) === null || ref === void 0 ? void 0 : ref.map(function(e) {
            return new Date(e);
        }));
        setDoluGirisler((ref1 = dates.doluGirisler) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
            return new Date(e);
        }));
        setDoluCikislar((ref2 = dates.doluCikislar) === null || ref2 === void 0 ? void 0 : ref2.map(function(e) {
            return new Date(e);
        }));
        setOdemeGunler((ref3 = dates.odemeGunler) === null || ref3 === void 0 ? void 0 : ref3.map(function(e) {
            return new Date(e);
        }));
        setOdemeGirisler((ref4 = dates.odemeGirisler) === null || ref4 === void 0 ? void 0 : ref4.map(function(e) {
            return new Date(e);
        }));
        setOdemeCikislar((ref5 = dates.odemeCikislar) === null || ref5 === void 0 ? void 0 : ref5.map(function(e) {
            return new Date(e);
        }));
    }, [
        dates
    ]);
    (0,react.useEffect)(function() {
        setdayStart((0,format["default"])(state2[0].startDate, "dd"));
        setdayEnd((0,format["default"])(state2[0].endDate, "dd"));
        setmonthStart((0,format["default"])(state2[0].startDate, "MMM", {
            locale: localeData
        }));
        setmonthEnd((0,format["default"])(state2[0].endDate, "MMM", {
            locale: localeData
        }));
    }, [
        state2,
        localeData
    ]);
    var ref12 = (0,react_detect_click_outside_dist/* useDetectClickOutside */.I)({
        onTriggered: CloseToggle
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white pt-4 pb-1 ml:py-5 pl-7 pr-5 flex items-center relative",
        ref: ref12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between flex-1 mr-10 items-center cursor-pointer",
                onClick: function(e) {
                    ToggleShow();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold text-brand-gray-2 text-13",
                                children: datepickerCheckIn
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-bold text-xl",
                                children: [
                                    dayStart,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs -top-0.5 relative inline-block",
                                        children: monthStart
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                        name: "DatepickerMiddle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold text-brand-gray-2 text-13",
                                children: datepickerCheckOut
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-bold text-xl",
                                children: [
                                    dayEnd,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs -top-0.5 relative inline-block",
                                        children: monthEnd
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                name: "DatepickerArrows"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute  z-20 flex-col py-5 pl-8 pr-7 bg-white w-full left-0 top-full border DatePickerFullWidth  " + (isShow ? "flex" : "hidden"),
                children: localeData && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* DateRange */.C0, {
                    editableDateInputs: false,
                    onChange: function(item) {
                        return onChange(item);
                    },
                    moveRangeOnFirstSelection: false,
                    ranges: state2,
                    showDateDisplay: false,
                    disabledDates: doluGunler,
                    locale: localeData,
                    months: width < 640 ? 1 : width < 768 ? 2 : width < 1024 ? 3 : 1,
                    minDate: new Date(),
                    showMonthAndYearPickers: false,
                    direction: "horizontal",
                    dayContentRenderer: customDayContent,
                    className: "availability-calendar"
                })
            })
        ]
    });
};
/* harmony default export */ var FastReservation_FormDatepicker = (FormDatepicker);

// EXTERNAL MODULE: ./components/Detail/CustomerItem.js
var CustomerItem = __webpack_require__(74840);
;// CONCATENATED MODULE: ./components/FastReservation/Customer.js






var Customer = function(param) {
    var customer = param.customer, setCustomer = param.setCustomer, _maxCapacity = param.maxCapacity, maxCapacity = _maxCapacity === void 0 ? 0 : _maxCapacity;
    var ToggleShow = function ToggleShow() {
        setIsShow(!isShow);
    };
    var CloseToggle = function CloseToggle() {
        setIsShow(false);
    };
    var ref = (0,TranslationContext/* useTranslation */.m)(), customerText = ref.customer, adult = ref.adult, child = ref.child, childAge = ref.childAge, infant = ref.infant, infantAge = ref.infantAge;
    var ref1 = (0,react.useState)(customer[0].yetiskin), yetiskin = ref1[0], setYetiskin = ref1[1];
    var ref2 = (0,react.useState)(customer[0].cocuk), cocuk = ref2[0], setCocuk = ref2[1];
    var ref3 = (0,react.useState)(maxCapacity), yetiskinMax = ref3[0], setYetiskinMax = ref3[1];
    var ref4 = (0,react.useState)(maxCapacity), cocukMax = ref4[0], setCocukMax = ref4[1];
    var ref5 = (0,react.useState)(customer[0].bebek), bebek = ref5[0], setBebek = ref5[1];
    var ref6 = (0,react.useState)(false), isShow = ref6[0], setIsShow = ref6[1];
    (0,react.useEffect)(function() {
        if (maxCapacity > 0) {
            if (parseInt(cocuk + yetiskin) <= parseInt(maxCapacity)) {
                setCustomer([
                    {
                        cocuk: cocuk,
                        yetiskin: yetiskin,
                        bebek: bebek
                    }, 
                ]);
            }
            setYetiskinMax(maxCapacity - cocuk);
            setCocukMax(maxCapacity - yetiskin);
        } else {
            setCustomer([
                {
                    cocuk: cocuk,
                    yetiskin: yetiskin,
                    bebek: bebek
                }, 
            ]);
        }
    }, [
        yetiskin,
        cocuk,
        bebek
    ]);
    var ref7 = (0,react_detect_click_outside_dist/* useDetectClickOutside */.I)({
        onTriggered: CloseToggle
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref7,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-white flex flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center pt-4 pb-1 ml:py-5 pl-8 pr-7 cursor-pointer",
                    onClick: function(e) {
                        ToggleShow();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-between flex-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-wrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-bold text-brand-gray-2 text-13 w-full",
                                        children: customerText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "font-bold text-xl mr-8",
                                        children: [
                                            yetiskin,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs -top-0.5 relative inline-block ml-1.5",
                                                children: adult
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "font-bold text-xl",
                                        children: [
                                            cocuk,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs -top-0.5 relative inline-block ml-1.5",
                                                children: child
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                                name: "ArrowDown"
                            })
                        })
                    ]
                }),
                isShow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col py-5 pl-8 pr-7 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerItem/* default */.Z, {
                            onchange: function(e) {
                                setYetiskin(e);
                            },
                            title: adult,
                            defaultValue: yetiskin,
                            min: 1,
                            max: yetiskinMax
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerItem/* default */.Z, {
                            onchange: function(e) {
                                setCocuk(e);
                            },
                            title: child,
                            defaultValue: cocuk,
                            subTitle: childAge,
                            max: cocukMax
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerItem/* default */.Z, {
                            onchange: function(e) {
                                setBebek(e);
                            },
                            title: infant,
                            subTitle: infantAge,
                            defaultValue: bebek
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var FastReservation_Customer = (Customer);

// EXTERNAL MODULE: ./components/ErrorComp.js
var ErrorComp = __webpack_require__(91450);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./components/Pages/Payment/Input.js
var Input = __webpack_require__(16719);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/yup-locales/dist/yup-locales.esm.js
var yup_locales_esm = __webpack_require__(18700);
;// CONCATENATED MODULE: ./validations/ContactSheme.js


if (true) es/* setLocale */.i_(yup_locales_esm.tr); // en: Yup varsayilan (Ingilizce) mesajlari
var ContactSheme = es/* object */.Ry().shape({
    name: es/* string */.Z_().required(),
    islm_id: es/* number */.Rx().required(),
    email: es/* string */.Z_().required().email(),
    telefonIsValid: es/* boolean */.O7().isTrue()
});

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./components/Reservation/PhoneInput.js
var PhoneInput = __webpack_require__(23515);
;// CONCATENATED MODULE: ./components/ContactModal.js









var ContactModal = function(param) {
    var result = param.result, id = param.id;
    var ref = (0,TranslationContext/* useTranslation */.m)(), nameSurname = ref.nameSurname, email = ref.email, phone = ref.phone, sendBtnText = ref.sendBtnText;
    var HandleSubmit = function(values, actions) {
        (0,api/* SendContact */.q5)(values).then(function(e) {
            if (e.data.error) {
                react_toastify_esm/* toast.error */.Am.error(e.data.error);
            } else {
                react_toastify_esm/* toast.success */.Am.success(e.data.success);
            }
        }).finally(function() {
            actions.setSubmitting(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: {
            name: "",
            islm_id: id,
            email: "",
            telefon: "",
            telefonIsValid: false
        },
        validationSchema: ContactSheme,
        onSubmit: HandleSubmit,
        children: function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "flex flex-wrap w-full",
                onSubmit: props.handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative z-0 w-full group p-1 mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            name: "name",
                            placeholder: " ",
                            label: nameSurname
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative z-0 w-full group p-1 mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            name: "email",
                            placeholder: " ",
                            label: email
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative z-0 w-full mt-4 group min-h-[70px] p-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput/* default */.Z, {
                            name: "telefon",
                            validname: "telefonIsValid",
                            label: phone,
                            mode: "simple",
                            isrequired: "required"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "h-0.25 bg-gray-400 w-full mt-8 mb-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "submit",
                        disabled: props.isSubmitting || !props.isValid || !props.dirty,
                        className: "mt-4 text-white mx-auto px-4 py-3 duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb] focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm text-center disabled:opacity-60 disabled:cursor-not-allowed",
                        children: sendBtnText
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var components_ContactModal = (ContactModal);

// EXTERNAL MODULE: ./context/context.js
var context = __webpack_require__(94268);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/styles.css
var styles = __webpack_require__(71541);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/theme/default.css
var theme_default = __webpack_require__(32049);
;// CONCATENATED MODULE: ./validations/PromotionCodeSheme.js


if (true) es/* setLocale */.i_(yup_locales_esm.tr); // en: Yup varsayilan (Ingilizce) mesajlari
var PromotionCodeSheme = es/* object */.Ry().shape({
    PromotionCode: es/* string */.Z_().required()
});

;// CONCATENATED MODULE: ./components/PromotionCodeModal.js









var PromotionCodeModal = function(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, CalculateFunc = param.CalculateFunc;
    var ref = (0,TranslationContext/* useTranslation */.m)(), promotionCode = ref.promotionCode, apply = ref.apply;
    var HandleSubmit = function(values, actions) {
        (0,api/* CheckPromotioncode */.GX)(values).then(function(e) {
            if (e.data.error) {
                react_toastify_esm/* toast.error */.Am.error(e.data.error);
                localStorage.removeItem("PromotionCode");
                CalculateFunc();
            } else {
                if (e.data.code) {
                    localStorage.setItem("PromotionCode", e.data.code.code);
                    CalculateFunc();
                    setIsOpen(false);
                }
            }
        }).finally(function() {
            actions.setSubmitting(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
        open: isOpen,
        onClose: function() {
            return setIsOpen(false);
        },
        className: "relative z-[999]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-0 bg-black/30",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-0 flex w-screen items-center justify-center p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Panel */.V.Panel, {
                    className: "w-full max-w-md rounded bg-white p-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                        initialValues: {
                            PromotionCode: ""
                        },
                        validationSchema: PromotionCodeSheme,
                        onSubmit: HandleSubmit,
                        children: function(props) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                className: "flex flex-wrap w-full",
                                onSubmit: props.handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative z-0 w-full group p-1 mt-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            name: "PromotionCode",
                                            placeholder: " ",
                                            label: promotionCode
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "submit",
                                        disabled: props.isSubmitting || !props.isValid || !props.dirty,
                                        className: "mt-4 text-white mx-auto px-4 py-3 duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb] focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm text-center disabled:opacity-60 disabled:cursor-not-allowed",
                                        children: apply
                                    })
                                ]
                            });
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_PromotionCodeModal = (PromotionCodeModal);

// EXTERNAL MODULE: ./components/ReservationUnavailable.js
var ReservationUnavailable = __webpack_require__(21837);
;// CONCATENATED MODULE: ./components/FastReservation/Isitma.js







var Isitma = function(param) {
    var result = param.result, buyPool = param.buyPool, setBuyPool = param.setBuyPool;
    var closeModal = function closeModal() {
        setIsOpen(false);
    };
    var openModal = function openModal() {
        setIsOpen(true);
    };
    var ref, ref1, ref2;
    var ref3 = (0,TranslationContext/* useTranslation */.m)(), heatingPoolTitle = ref3.heatingPoolTitle, dateLabel = ref3.dateLabel, feeLabel = ref3.feeLabel, statusLabel = ref3.statusLabel, free = ref3.free, notUsable = ref3.notUsable, usable = ref3.usable, closeBtn = ref3.closeBtn, wantHeatedPool = ref3.wantHeatedPool, heatedPoolDatesPre = ref3.heatedPoolDatesPre, heatedPoolDatesClick = ref3.heatedPoolDatesClick;
    var ref4 = (0,react.useState)(false), isOpen = ref4[0], setIsOpen = ref4[1];
    var isitmaTarihler = result === null || result === void 0 ? void 0 : (ref = result.result) === null || ref === void 0 ? void 0 : ref.isitmaUcretleri;
    var isitmaHizmetDisiVarmi = result === null || result === void 0 ? void 0 : (ref1 = result.result) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.isitmaUcretleri) === null || ref2 === void 0 ? void 0 : ref2.filter(function(e) {
        return e.isitmaHizmetDisi == "1";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                appear: true,
                show: isOpen,
                as: react.Fragment,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
                    as: "div",
                    className: "relative z-[9999]",
                    onClose: closeModal,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fixed inset-0 bg-black bg-opacity-25"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fixed inset-0 overflow-y-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex min-h-full items-center justify-center p-4 text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                                    as: react.Fragment,
                                    enter: "ease-out duration-300",
                                    enterFrom: "opacity-0 scale-95",
                                    enterTo: "opacity-100 scale-100",
                                    leave: "ease-in duration-200",
                                    leaveFrom: "opacity-100 scale-100",
                                    leaveTo: "opacity-0 scale-95",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Panel */.V.Panel, {
                                        className: "w-full max-w-4xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Title */.V.Title, {
                                            as: "h3",
                                            className: "text-lg text-center font-medium leading-6 text-gray-900 mb-3 ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "mb-5 text-lg",
                                                    children: heatingPoolTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "overflow-auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                        className: "min-w-full bg-white border border-gray-200",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                    className: "bg-gray-50 text-xs font-medium text-gray-500 uppercase tracking-wider",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                            className: "px-6 py-3",
                                                                            children: dateLabel
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                            className: "px-6 py-3",
                                                                            children: feeLabel
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                            className: "px-6 py-3",
                                                                            children: statusLabel
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                                className: "divide-y divide-gray-200",
                                                                children: isitmaTarihler === null || isitmaTarihler === void 0 ? void 0 : isitmaTarihler.map(function(isitmaData, index) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                        className: "".concat(isitmaData.isitmaHizmetDisi == "1" ? "bg-red-100" : "bg-green-100"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                className: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900",
                                                                                children: (0,format["default"])(new Date(isitmaData.tarih), "dd.MM.yyyy")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                                                                                children: isitmaData.isitmaHizmetDisi == "1" ? "-" : isitmaData.isitmaFiyat == "0" ? free : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                                                                                    Symbol: result.result.symbol,
                                                                                    value: isitmaData.isitmaFiyat
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500",
                                                                                children: isitmaData.isitmaHizmetDisi == "1" ? notUsable : usable
                                                                            })
                                                                        ]
                                                                    }, index);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: "inline-flex mt-5 justify-center rounded-md border border-transparent bg-red-400 px-4 py-2 text-sm font-medium text-white hover:bg-red-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-800 focus-visible:ring-offset-2",
                                                    onClick: closeModal,
                                                    children: closeBtn
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-detail-border-color h-0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "py-3 px-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "bg-white p-2 inline-flex items-center cursor-pointer w-full justify-between content-center ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mr-1 text-xs font-bold text-gray-900 ",
                                children: wantHeatedPool
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                value: "",
                                onChange: function() {
                                    return setBuyPool(!buyPool);
                                },
                                className: "sr-only peer",
                                checked: buyPool
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-brand-color-primary"
                            })
                        ]
                    }),
                    isitmaHizmetDisiVarmi && buyPool ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-xs text-gray-900 underline inline-block w-full cursor-pointer",
                        onClick: openModal,
                        children: [
                            heatedPoolDatesPre,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: heatedPoolDatesClick
                            })
                        ]
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-detail-border-color h-0.5"
            })
        ]
    });
};
/* harmony default export */ var FastReservation_Isitma = (Isitma);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js
var differenceInDays = __webpack_require__(67803);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/tr/index.js + 5 modules
var tr = __webpack_require__(12329);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/FastReservation/AvailableDates.js








var AvailableDates = function(param) {
    var availableDatesData = param.availableDatesData, setAvailableDatesModal = param.setAvailableDatesModal, error = param.error, setError = param.setError, result = param.result, setResult = param.setResult, total = param.total, setTotal = param.setTotal;
    var ref;
    var localeData =  false ? 0 : tr/* default */.Z;
    var ref1 = (0,TranslationContext/* useTranslation */.m)(), availableDatesText = ref1.availableDatesText, nightLabel = ref1.nightLabel, selectBtn = ref1.selectBtn, loadingDots = ref1.loadingDots, continueAnyway = ref1.continueAnyway, availableDatesWarning = ref1.availableDatesWarning;
    var selectAvailableDate = function(e) {
        setTotal([
            {
                startDate: new Date(e.Item1),
                endDate: new Date(e.Item2),
                key: "selection",
                isShow: 0
            }, 
        ]);
    };
    var SendRequest = function() {
        setError(false);
        setAvailableDatesModal(false);
        //set success:200 on result
        setResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), {
            success: 200,
            disableRetryCalc: true
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    return setAvailableDatesModal(false);
                },
                className: "absolute text-gray-500 top-4 right-4 hover:text-gray-800",
                children: "\u2715"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "max-w-xs mb-2 text-lg font-semibold text-center text-blue-900",
                children: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-8 text-sm text-center text-gray-600",
                children: availableDatesText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid gap-2 w-full justify-center pb-2 max-h-[400px] lg:max-h-[500px] overflow-y-auto",
                ref: parent,
                children: availableDatesData.length > 0 ? availableDatesData === null || availableDatesData === void 0 ? void 0 : availableDatesData.map(function(item, key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-[58px] relative items-center justify-between px-2 gap-2 py-1 mb-4 border rounded-xl ".concat((item === null || item === void 0 ? void 0 : item.isMostSuitable) ? "border-yellow-400" : ""),
                        children: [
                            (item === null || item === void 0 ? void 0 : item.isMostSuitable) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/star.svg",
                                    width: 16,
                                    height: 16,
                                    className: "absolute top-0 left-0 -mt-2 -ml-2",
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center content-center justify-center flex-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-center gap-2 ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-sm font-bold text-orange-500",
                                                children: (0,format["default"])(new Date(item.Item1), "d MMM ccc", {
                                                    locale: localeData
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-gray-500",
                                                children: "\u2192"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-sm font-bold text-orange-500",
                                                children: (0,format["default"])(new Date(item.Item2), "d MMM ccc", {
                                                    locale: localeData
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            (0,differenceInDays["default"])(new Date(item.Item2), new Date(item.Item1)),
                                            " ",
                                            nightLabel
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return selectAvailableDate(item);
                                },
                                className: "px-3 py-1 font-semibold text-white transition-all rounded-full bg-black",
                                children: selectBtn
                            })
                        ]
                    }, key);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        " ",
                        loadingDots
                    ]
                })
            }),
            (result === null || result === void 0 ? void 0 : (ref = result.apiResponse) === null || ref === void 0 ? void 0 : ref.Status) == "AvailableHasWarningRule" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: SendRequest,
                        className: "w-full py-3 mb-4 font-semibold text-white rounded-lg bg-primary hover:bg-primary-dark",
                        children: continueAnyway
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs text-center text-red-500",
                        children: availableDatesWarning
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FastReservation_AvailableDates = (AvailableDates);

;// CONCATENATED MODULE: ./hooks/useExtraServices.js



var useExtraServices = function(AvailableExtraServices, setSelectedServices) {
    // Zorunlu ek servisleri hesapla
    var mandatoryServices = react.useMemo(function() {
        if (!AvailableExtraServices) return [];
        var serviceMap = new Map();
        AvailableExtraServices.forEach(function(day) {
            day.extraServices.forEach(function(service) {
                if (service.IsOptional === "0") {
                    var key = "".concat(service.id, "-").concat(service.title);
                    if (!serviceMap.has(key)) {
                        serviceMap.set(key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, service), {
                            totalDays: 1
                        }));
                    } else {
                        var existing = serviceMap.get(key);
                        existing.totalDays += 1;
                        serviceMap.set(key, existing);
                    }
                }
            });
        });
        return Array.from(serviceMap.values());
    }, [
        AvailableExtraServices
    ]);
    // Opsiyonel ek servisleri hesapla
    var optionalServices = react.useMemo(function() {
        if (!AvailableExtraServices) return [];
        var serviceMap = new Map();
        AvailableExtraServices.forEach(function(day) {
            day.extraServices.forEach(function(service) {
                if (service.IsOptional === "1") {
                    var key = "".concat(service.id, "-").concat(service.title);
                    if (!serviceMap.has(key)) {
                        serviceMap.set(key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, service), {
                            totalDays: 1
                        }));
                    } else {
                        var existing = serviceMap.get(key);
                        existing.totalDays += 1;
                        serviceMap.set(key, existing);
                    }
                }
            });
        });
        return Array.from(serviceMap.values());
    }, [
        AvailableExtraServices
    ]);
    // Servis seçimi değiştiğinde
    var handleServiceChange = function(serviceId) {
        setSelectedServices(function(prev) {
            var newSelected = new Set(prev);
            if (newSelected.has(serviceId)) {
                newSelected.delete(serviceId);
            } else {
                newSelected.add(serviceId);
            }
            return newSelected;
        });
    };
    return {
        mandatoryServices: mandatoryServices,
        optionalServices: optionalServices,
        handleServiceChange: handleServiceChange
    };
};

// EXTERNAL MODULE: ./components/KiralaGelBanner.js
var KiralaGelBanner = __webpack_require__(14082);
;// CONCATENATED MODULE: ./components/FastReservation.js















 // main css file
 // theme css file









var FastReservation = function(param) {
    var id = param.id, _setreservationResult = param.setreservationResult, setreservationResult = _setreservationResult === void 0 ? null : _setreservationResult, _setParam = param.setParam, setParam = _setParam === void 0 ? null : _setParam, _defaultState = param.defaultState, defaultState = _defaultState === void 0 ? null : _defaultState, _useQueryDates = param.useQueryDates, useQueryDates = _useQueryDates === void 0 ? true : _useQueryDates, _onSubmit = param.onSubmit, onSubmit = _onSubmit === void 0 ? null : _onSubmit, _className = param.className, className = _className === void 0 ? null : _className, _kisi = param.kisi, kisi = _kisi === void 0 ? null : _kisi, _isActive = param.isActive, isActive = _isActive === void 0 ? 1 : _isActive, paymentType = param.paymentType, isAppWebView = param.isAppWebView, deviceType = param.deviceType;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,TranslationContext/* useTranslation */.m)(), reservationSubmitButtonText = ref4.reservationSubmitButtonText, notDates = ref4.notDates, appliedDiscount = ref4.appliedDiscount, ihaveapromotioncode = ref4.ihaveapromotioncode, loadingDots = ref4.loadingDots, payNow = ref4.payNow;
    var localeData = (0,useLocale/* default */.Z)();
    var ref5 = (0,react.useContext)(context/* StoreContext */.x), currentRoutingTypeId = ref5.currentRoutingTypeId, page = ref5.page;
    var ref6 = (0,react.useState)(false), result = ref6[0], setResult = ref6[1];
    var ref7 = (0,react.useState)(false), error = ref7[0], setError = ref7[1];
    var ref8 = (0,react.useState)(false), warning = ref8[0], setWarning = ref8[1];
    var ref9 = (0,react.useState)(false), isLoading = ref9[0], setIsLoading = ref9[1];
    var ref10 = (0,react.useState)([]), disabledDates = ref10[0], setDisabledDates = ref10[1];
    var ref11 = (0,react.useState)(false), availableDatesModal = ref11[0], setAvailableDatesModal = ref11[1];
    var ref12 = (0,react.useState)([]), availableDatesData = ref12[0], setAvailableDatesData = ref12[1];
    var AvailableExtraServices = (result || {}).AvailableExtraServices;
    var ref13 = (0,react.useState)(false), isOpen = ref13[0], setIsOpen = ref13[1];
    var ref14 = (0,react.useState)(((ref = router.query) === null || ref === void 0 ? void 0 : ref.selectedServices) ? new Set(router.query.selectedServices.split(",")) : new Set()), selectedServices = ref14[0], setSelectedServices = ref14[1];
    var ref15 = (0,react.useState)(((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.buyPool) == "1" ? 1 : 0), buyPool = ref15[0], setBuyPool = ref15[1];
    var ref16 = (0,react.useState)(defaultState ? defaultState : [
        {
            startDate: useQueryDates && router.query.start ? new Date(router.query.start) : new Date(),
            endDate: useQueryDates && router.query.end ? new Date(router.query.end) : new Date(),
            key: "selection",
            isShow: 0
        }, 
    ]), state2 = ref16[0], setState2 = ref16[1];
    var ref17 = (0,react.useState)([
        {
            yetiskin: router.query.yetiskin ? router.query.yetiskin : 1,
            cocuk: router.query.cocuk ? router.query.cocuk : 0,
            bebek: router.query.bebek ? router.query.bebek : 0
        }, 
    ]), customer = ref17[0], setCustomer = ref17[1];
    (0,react.useEffect)(function() {
        CalculateFunc();
    }, [
        state2,
        buyPool,
        selectedServices
    ]);
    (0,react.useEffect)(function() {
        if (setParam) setParam({
            buyPool: buyPool ? 1 : 0
        });
    }, [
        buyPool
    ]);
    (0,react.useEffect)(function() {
        if (setParam) setParam({
            selectedServices: Array.from(selectedServices).join(",")
        });
    }, [
        selectedServices
    ]);
    var CalculateFunc = function() {
        if ((0,format["default"])(state2[0].startDate, "yyyy-MM-dd", {
            locale: localeData
        }) !== (0,format["default"])(state2[0].endDate, "yyyy-MM-dd", {
            locale: localeData
        })) {
            setIsLoading(true);
            (0,api/* Calculate */.Pz)({
                start: (0,format["default"])(state2[0].startDate, "yyyy-MM-dd", {
                    locale: localeData
                }),
                end: (0,format["default"])(state2[0].endDate, "yyyy-MM-dd", {
                    locale: localeData
                }),
                EntityId: id,
                currentRoutingTypeId: currentRoutingTypeId,
                PromotionCode: localStorage.getItem("PromotionCode") || (isAppWebView ? "MobilApp.1000" : ""),
                pool_fee: buyPool ? 1 : 0,
                selectedServices: Array.from(selectedServices).join(",")
            }).then(function(response) {
                var ref, ref1, ref2;
                setWarning(false);
                setError(false);
                if (router.query.disableRetryCalc == "true" && !(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.error)) {
                    response.data.success = 200;
                    response.data.disableRetryCalc = true;
                }
                setResult(response.data);
                if (setreservationResult) setreservationResult(response.data);
                if (((ref1 = response.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.result) === null || ref2 === void 0 ? void 0 : ref2.isitmaHizmetDisi) == "1") setBuyPool(0);
                response.data.error ? setError(response.data.error) : setError(false);
                response.data.warning ? setWarning(response.data.warning) : setWarning(false);
            }).finally(function() {
                setIsLoading(false);
            }).catch(function(error) {
                setError(error.message);
            });
        }
        setParam && setParam({
            start: (0,format["default"])(state2[0].startDate, "yyyy-MM-dd", {
                locale: localeData
            }),
            end: (0,format["default"])(state2[0].endDate, "yyyy-MM-dd", {
                locale: localeData
            })
        });
    };
    (0,react.useEffect)(function() {
        setParam && setParam({
            yetiskin: customer[0].yetiskin,
            cocuk: customer[0].cocuk,
            bebek: customer[0].bebek
        });
    }, [
        customer
    ]);
    (0,react.useEffect)(function() {
        (0,api/* GetAvailability */.Nn)(id).then(function(e) {
            setDisabledDates(e.data.data);
        });
        setResult(false);
    }, [
        id
    ]);
    (0,react.useEffect)(function() {
        if ((result === null || result === void 0 ? void 0 : result.ShowAvailableDates) && (result === null || result === void 0 ? void 0 : result.disableRetryCalc) != true) {
            setAvailableDatesModal(true);
        } else {
            setAvailableDatesModal(false);
        }
    }, [
        result
    ]);
    (0,react.useEffect)(function() {
        if (defaultState) setState2(defaultState);
    }, [
        defaultState
    ]);
    (0,react.useEffect)(function() {
        setAvailableDatesData([]);
        if (availableDatesModal) {
            (0,api/* GetAvailableReservations */.TI)({
                EntityId: id,
                start: (0,format["default"])(state2[0].startDate, "yyyy-MM-dd"),
                end: (0,format["default"])(state2[0].endDate, "yyyy-MM-dd")
            }).then(function(e) {
                if (e.data) {
                    // Gelen veriyi Item1 alanına göre sıralayın
                    var sortedData = (0,_to_consumable_array/* default */.Z)(e.data).sort(function(a, b) {
                        return new Date(a.Item1) - new Date(b.Item1);
                    });
                    // Seçilen giriş tarihine en yakın olanı bulun ve işaretleyin
                    var closestDate = findClosestDate(sortedData, state2[0].startDate);
                    var updatedData = sortedData.map(function(item) {
                        return item.Item1 === closestDate ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            isMostSuitable: true
                        }) : item;
                    });
                    // Sıralanmış ve işaretlenmiş veriyi set edin
                    setAvailableDatesData(updatedData);
                }
            });
        }
    }, [
        availableDatesModal
    ]);
    var findClosestDate = function(dates, targetDate) {
        if (dates.length > 0) {
            return dates.reduce(function(closest, current) {
                var currentDiff = Math.abs((0,differenceInDays["default"])(new Date(current.Item1), new Date(targetDate)));
                var closestDiff = Math.abs((0,differenceInDays["default"])(new Date(closest.Item1), new Date(targetDate)));
                return currentDiff < closestDiff ? current : closest;
            }).Item1;
        }
        return null;
    };
    var submitForm = function() {
        if ((0,format["default"])(state2[0].startDate, "yyyy-MM-dd", {
            locale: localeData
        }) == (0,format["default"])(state2[0].endDate, "yyyy-MM-dd", {
            locale: localeData
        })) {
            setError(notDates);
        } else {
            if (onSubmit) onSubmit();
            router.push({
                pathname: "/" + page.Reservation.url,
                query: {
                    ProductId: id,
                    start: (0,format["default"])(state2[0].startDate, "yyyy-MM-dd", {
                        locale: localeData
                    }),
                    end: (0,format["default"])(state2[0].endDate, "yyyy-MM-dd", {
                        locale: localeData
                    }),
                    yetiskin: customer[0].yetiskin,
                    cocuk: customer[0].cocuk,
                    bebek: customer[0].bebek,
                    buyPool: buyPool ? 1 : 0,
                    disableRetryCalc: result === null || result === void 0 ? void 0 : result.disableRetryCalc,
                    selectedServices: Array.from(selectedServices).join(",")
                }
            });
        }
    };
    var ref18 = useExtraServices(AvailableExtraServices, setSelectedServices), mandatoryServices = ref18.mandatoryServices, optionalServices = ref18.optionalServices, handleServiceChange = ref18.handleServiceChange;
    if (isActive == "0") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReservationUnavailable/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FastReservation_FormDatepicker, {
                state2: state2,
                setState2: setState2,
                setError: setError,
                dates: disabledDates
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-detail-border-color h-0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FastReservation_Customer, {
                customer: customer,
                setCustomer: setCustomer,
                maxCapacity: kisi
            }),
            ((page === null || page === void 0 ? void 0 : page.IsitmaVar) == "1" || (page === null || page === void 0 ? void 0 : (ref2 = page.Product) === null || ref2 === void 0 ? void 0 : ref2.IsitmaVar) == "1") && result.result && ((ref3 = result.result) === null || ref3 === void 0 ? void 0 : ref3.isitmaHizmetDisi) != "1" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FastReservation_Isitma, {
                buyPool: buyPool,
                result: result,
                setBuyPool: setBuyPool
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white relative transition-opacity duration-200 " + (currentRoutingTypeId == "ProductDetail" ? "lg:p-3" : "") + " " + className + (isLoading ? " opacity-60 pointer-events-none" : ""),
                children: [
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 z-10 flex items-center justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-8 h-8 set-loading text-orange animate-spin rounded-full border-4 border-solid border-orange border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]",
                            role: "status",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]",
                                children: loadingDots
                            })
                        })
                    }),
                    (result === null || result === void 0 ? void 0 : result.success) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FastReservation_Result, {
                        result: result,
                        buyPool: buyPool,
                        isLoading: isLoading,
                        paymentType: paymentType,
                        mandatoryServices: mandatoryServices,
                        optionalServices: optionalServices,
                        selectedServices: selectedServices,
                        handleServiceChange: handleServiceChange,
                        AvailableExtraServices: AvailableExtraServices,
                        isAppWebView: isAppWebView
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "p-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComp/* default */.Z, {
                            children: error
                        })
                    }),
                    warning && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "p-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComp/* default */.Z, {
                            type: "warning",
                            children: warning
                        })
                    }),
                    !error && currentRoutingTypeId != "Reservation" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FastReservation_SendBtn, {
                                submitForm: submitForm,
                                disabled: error || !result,
                                children: (result === null || result === void 0 ? void 0 : result.BookableDirectly) === "1" ? payNow : reservationSubmitButtonText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs underline cursor-pointer ",
                                onClick: function() {
                                    return setIsOpen(true);
                                },
                                children: localStorage.getItem("PromotionCode") ? appliedDiscount.replace("{code}", localStorage.getItem("PromotionCode")) : ihaveapromotioncode
                            })
                        ]
                    }) : "",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sm:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KiralaGelBanner/* default */.Z, {
                            src: "/images/kiralagel-banner/575x260.png",
                            deviceType: deviceType
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PromotionCodeModal, {
                        setIsOpen: setIsOpen,
                        isOpen: isOpen,
                        CalculateFunc: CalculateFunc
                    }),
                    (result === null || result === void 0 ? void 0 : result.StopSell) == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ContactModal, {
                        id: id,
                        result: result
                    })
                ]
            }),
            availableDatesModal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 transition-opacity bg-black bg-opacity-50 z-[99998]",
                        onClick: function() {
                            return setAvailableDatesModal(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed flex items-center justify-center bg-white translate-y-full -translate-x-1/2 w-full sm:w-[600px] z-[99999] pb-4 bottom-0 border transition-[transform] duration-200 border-solid border-lightWhite-1100 rounded-t-20  left-1/2  text-black ".concat(availableDatesModal ? "!translate-y-0" : "", " "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative overflow-hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative flex flex-col items-center p-6 ",
                                children: availableDatesModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(FastReservation_AvailableDates, {
                                    availableDatesData: availableDatesData,
                                    setAvailableDatesModal: setAvailableDatesModal,
                                    error: error,
                                    setError: setError,
                                    result: result,
                                    setResult: setResult,
                                    total: state2,
                                    setTotal: setState2
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_FastReservation = (FastReservation);


/***/ }),

/***/ 16719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var react_mask_field__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18935);








"use client";
var Input = function(_param) {
    var label = _param.label, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "label"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,formik__WEBPACK_IMPORTED_MODULE_2__/* .useField */ .U$)(props), 3), field = ref[0], meta = ref[1], helpers = ref[2];
    // useEffect(() => {
    //   if (field.value) helpers.setTouched(true);
    // }, [field.value]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            props.mask ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_mask_field__WEBPACK_IMPORTED_MODULE_3__/* .MaskField */ .V, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: "border-gray-300 block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border  appearance-none   focus:outline-none focus:ring-0 focus:border-brand-color-secondary peer " + (!meta.error && field.value ? "border-green-500 focus:!border-green-500" : "") + (meta.error && field.value ? " border-red-500 focus:!border-red-500" : " ")
            }, field, props), {
                id: props.id || props.name
            })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: "border-gray-300 block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border  appearance-none   focus:outline-none focus:ring-0 focus:border-brand-color-secondary peer " + (!meta.error && meta.touched ? "border-green-500 focus:border-green-500" : "") + (meta.error && meta.touched ? " border-red-500 focus:border-red-500" : " ")
            }, field, props), {
                id: props.id || props.name
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: props.name,
                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-brand-color-secondary duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-brand-color-secondary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                children: label
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 23515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86408);
/* harmony import */ var react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2_lib_style_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82175);
/* harmony import */ var _styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35928);
/* harmony import */ var _styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_phone_input_2_lang_tr_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95509);









var PhoneInputW = function(_param) {
    var label = _param.label, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "label"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,formik__WEBPACK_IMPORTED_MODULE_4__/* .useField */ .U$)(props), 3), field = ref[0], meta = ref[1], helpers = ref[2];
    var setError = helpers.setError, setValue = helpers.setValue, setTouched = helpers.setTouched;
    var ref1 = (0,formik__WEBPACK_IMPORTED_MODULE_4__/* .useFormikContext */ .u6)(), values = ref1.values, submitForm = ref1.submitForm, submitCount = ref1.submitCount, setFieldValue = ref1.setFieldValue;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: "Turkey",
        dialCode: "90",
        countryCode: "tr",
        format: "+.. ... ... .. .."
    }), country = ref2[0], setCountry = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isError = ref3[0], setIsError = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (country) {
            var pattern = new RegExp("^\\d{".concat(country.format.replaceAll(" ", "").replace("+", "").length, "}$"));
            if (!meta.touched) setTouched(true);
            if (props.isrequired == "required") {
                if (country.countryCode == "tr") {
                    setIsError(pattern.test(field.value) == false);
                    setFieldValue(props.validname, !(pattern.test(field.value) == false));
                } else {
                    setIsError(false);
                    setFieldValue(props.validname, true);
                }
            //setFieldValue(props.validname, true);
            } else {
                if (field.value.length <= country.dialCode.length) {
                    setTouched(false);
                    setFieldValue(props.validname, true);
                    setError(false);
                } else {
                    //setIsError(pattern.test(val) == false);
                    if (!meta.touched) setTouched(true);
                    //setFieldValue(
                    //  props.validname,
                    //  pattern.test(val) == true ? true : null
                    //);
                    setFieldValue(props.validname, true);
                }
            }
        }
    }, [
        field.value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative text-brand-gray-9 bg-white rounded-md shadow-[0_22px_24px_0_rgba(226,236,240,0.13)] flex items-center ".concat(props.mode == "simple" ? "h-full border px-6" : "h-[70px]  px-9", "  ").concat(!meta.error && meta.touched && !isError ? "".concat(props.mode == "simple" ? "border" : "border-2", "  border-green-400") : null, " ").concat(meta.error && meta.touched || isError && field.value.length > country.dialCode.length || submitCount > 0 && !field.value ? "".concat(props.mode == "simple" ? "border" : "border-2", " border-red-400") : null),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "font-semibold text-sm",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "h-full w-0.25 ml-5 mr-6 flex-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_2___default()), {
                        className: (_styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8___default().PhoneInput),
                        localization: react_phone_input_2_lang_tr_json__WEBPACK_IMPORTED_MODULE_5__,
                        country: "tr",
                        inputClass: (_styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8___default().input),
                        buttonClass: (_styles_PhoneInput_module_css__WEBPACK_IMPORTED_MODULE_8___default().dropDown),
                        preferredCountries: [
                            "tr"
                        ],
                        enableLongNumbers: true,
                        onChange: function(value, country, e, formattedValue) {
                            setValue(value);
                            setCountry(country);
                        },
                        value: field.value
                    }),
                    props.isrequired && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: " absolute right-4 top-4",
                        children: "*"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PhoneInputW);


/***/ }),

/***/ 21837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73040);



var ReservationUnavailable = function(param) {
    var message = param.message;
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .m)(), warning = ref.warning, reservationUnavailableMessage = ref.reservationUnavailableMessage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex p-4 my-4 mx-3 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400",
        role: "alert",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: message || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "font-medium",
                        children: warning
                    }),
                    " ",
                    reservationUnavailableMessage
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReservationUnavailable);


/***/ }),

/***/ 35928:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PhoneInput":"PhoneInput_PhoneInput__q7Kkj","PhoneInputCountry":"PhoneInput_PhoneInputCountry__i4tLe","dropDown":"PhoneInput_dropDown__K8cbG","input":"PhoneInput_input__zsoED"};

/***/ })

}]);